import React, { useState, useEffect, useRef } from 'react';

// Datos de ejemplo para las fichas
const cardData = [
  {
    id: 1,
    title: "Actividades Extractivas",
    description: "Información detallada sobre bancos de material geológico y su regulación ambiental.",
    imageUrl: "images/FichasInfo/PORTADA FICHA_ACTIVIDADES EXTRACTIVAS.jpg",
    pdfUrl: "https://siga.jalisco.gob.mx/ordenamiento/archivos/FichasInformativas/ACTIVIDADES_EXTRACTIVAS.pdf",
    category: "Extractivismo",
    fileSize: "3.38 MB",
    pages: 2
  },
  {
    id: 2,
    title: "Desarrollos Inmobiliarios",
    description: "Lineamientos para proyectos en centros de población y zonas costeras.",
    imageUrl: "images/FichasInfo/PORTADA FICHA_DESARROLLOS INMOBILIARIOS.jpg",
    pdfUrl: "https://siga.jalisco.gob.mx/ordenamiento/archivos/FichasInformativas/DESARROLLOS_IMNOBILIARIOS.pdf",
    category: "Urbanismo",
    fileSize: "3.23 MB",
    pages: 2
  },
  {
    id: 3,
    title: "Manejo de Energías Renovables",
    description: "Guía sobre la disposición final y tratamiento de residuos urbanos e industriales.",
    imageUrl: "images/FichasInfo/PORTADA FICHA_ENERGIAS RENOVABLES.jpg",
    pdfUrl: "https://siga.jalisco.gob.mx/ordenamiento/archivos/FichasInformativas/ENERGI%CC%81AS_RENOVABLES.pdf",
    category: "Energía",
    fileSize: "4.67 MB",
    pages: 2
  },
  {
    id: 4,
    title: "Granjas Pecuarias",
    description: "Estrategias para la protección y uso eficiente de los recursos hídricos superficiales y subterráneos.",
    imageUrl: "images/FichasInfo/PORTADA FICHA_GRANJAS PECUARIAS.jpg",
    pdfUrl: "https://siga.jalisco.gob.mx/ordenamiento/archivos/FichasInformativas/GRANJAS_PECUARIAS.pdf",
    category: "Agroindustria",
    fileSize: "7.91 MB",
    pages: 2
  },
  {
    id: 5,
    title: "Poligonos Industriales y de Almacenamiento",
    description: "Ficha técnica sobre la conservación de especies nativas y gestión de ANP.",
    imageUrl: "images/FichasInfo/PORTADA FICHA_POLIGONOS INDUSTRIALES Y ALMACENAMIENTOS.jpg",
    pdfUrl: "https://siga.jalisco.gob.mx/ordenamiento/archivos/FichasInformativas/INDUSTRIA.pdf",
    category: "Industria",
    fileSize: "29.1 MB",
    pages: 2
  },
   {
    id: 6,
     title: "Cabañas y casas de Campo",
    description: "Directrices para la gestión de residuos peligrosos en proyectos residenciales y turísticos.",
    imageUrl: "images/FichasInfo/CABAÑAS-Y-CASAS-DE-CAMPO.png",
    pdfUrl: "https://siga.jalisco.gob.mx/ordenamiento/archivos/FichasInformativas/CABAN%CC%83AS_Y_CASAS_DE_CAMPO.pdf",
    category: "Urbanismo",
     fileSize: "24.8 MB",
     pages: 2
   }
];

// Componente para la Ficha Documento con fondo transparente
const FichaDocumento = ({ data, onCardClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const handleError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
  };

  return (
    <div
      className="group relative rounded-3xl overflow-hidden shadow-2xl hover:shadow-[0_20px_50px_rgba(0,0,0,0.3)] transition-all duration-500 transform hover:-translate-y-3 cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onCardClick(data)}
    >
      {/* Contenedor principal con imagen de fondo */}
      <div className="relative h-[600px] w-full overflow-hidden">
        {/* Imagen de fondo que ocupa toda la tarjeta */}
        <img
          src={data.imageUrl}
          alt={data.title}
          className="absolute inset-0 w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
          onError={handleError}
        />
        
        {/* Overlay oscuro para mejorar legibilidad */}
        <div className={`absolute inset-0 bg-gradient-to-t from-black/95 via-black/70 to-black/30 transition-all duration-500 ${isHovered ? 'opacity-90' : 'opacity-80'}`}></div>
        
        {/* Overlay de color en hover */}
        <div className={`absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-cyan-500/20 transition-all duration-500 ${isHovered ? 'opacity-40' : 'opacity-0'}`}></div>
        
        {/* Contenido sobre la imagen */}
        <div className="relative h-full flex flex-col justify-between p-8">
          {/* Parte superior: Categoría y badge */}
          <div className="flex justify-between items-start">
            <span className="px-4 py-2 bg-white/20 backdrop-blur-sm text-white text-sm font-bold rounded-full border border-white/30">
              {data.category}
            </span>
            
            <div className="flex flex-col items-end gap-2">
              <span className="px-3 py-1 bg-red-600 text-white text-xs font-bold rounded-full flex items-center gap-1.5">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
                  <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
                </svg>
                PDF
              </span>
              
              <div className="text-white/90 text-xs font-medium backdrop-blur-sm bg-black/20 px-3 py-1.5 rounded-lg">
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="7 10 12 15 17 10"/>
                      <line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                    {data.fileSize}
                  </span>
                  <span className="flex items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                      <line x1="3" y1="9" x2="21" y2="9"/>
                      <line x1="9" y1="21" x2="9" y2="9"/>
                    </svg>
                    {data.pages} págs
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Parte central: Título y descripción */}
          <div className="mt-8">
            <h3 className="text-3xl font-black text-white mb-4 leading-tight transition-all duration-500 group-hover:text-cyan-300">
              {data.title}
            </h3>
            
            <p className={`text-white/90 text-base leading-relaxed transition-all duration-500 ${isHovered ? 'opacity-100' : 'opacity-90'}`}>
              {data.description}
            </p>
          </div>
          
          {/* Parte inferior: Botón de acción */}
          <div className="mt-8">
            <div className={`relative overflow-hidden rounded-2xl transition-all duration-500 transform ${isHovered ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-90'}`}>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/90 to-cyan-500/90 backdrop-blur-sm rounded-2xl"></div>
              
              <button className="relative w-full py-4 px-6 text-white font-bold text-lg flex items-center justify-between group/btn">
                <span className="flex items-center gap-3">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    className="transition-transform duration-500 group-hover/btn:rotate-12"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                  Descargar Ficha Técnica
                </span>
                
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  className="transition-transform duration-500 group-hover/btn:translate-x-2"
                >
                  <path d="M5 12h14"/>
                  <path d="m12 5 7 7-7 7"/>
                </svg>
              </button>
              
              {/* Efecto de brillo en hover */}
              <div className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/btn:translate-x-full transition-transform duration-1000 ${isHovered ? 'opacity-100' : 'opacity-0'}`}></div>
            </div>
            
            {/* Indicador de hover sutil */}
            <div className={`h-1 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-full mt-4 transition-all duration-500 ${isHovered ? 'w-full opacity-100' : 'w-1/4 opacity-50'}`}></div>
          </div>
        </div>
        
        {/* Borde sutil en hover */}
        <div className={`absolute inset-0 border-2 border-white/30 rounded-3xl transition-all duration-500 ${isHovered ? 'opacity-100' : 'opacity-0'}`}></div>
      </div>
    </div>
  );
};

// Componente Principal
const MainAppLogic = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [stats, setStats] = useState({
    total: 0,
    totalSize: '0 MB',
    totalPages: 0
  });
  
  const modalRef = useRef(null);

  // Calcular estadísticas
  useEffect(() => {
    const totalSize = cardData.reduce((acc, item) => {
      const size = parseFloat(item.fileSize);
      return acc + size;
    }, 0);
    
    const totalPages = cardData.reduce((acc, item) => acc + item.pages, 0);
    
    setStats({
      total: cardData.length,
      totalSize: `${totalSize.toFixed(1)} MB`,
      totalPages
    });
  }, []);

  // Filtrar fichas
  const filteredCards = cardData.filter(card => {
    const matchesSearch = card.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         card.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         card.category.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesCategory = filterCategory === 'all' || card.category === filterCategory;
    
    return matchesSearch && matchesCategory;
  });

  // Obtener categorías únicas
  const categories = ['all', ...new Set(cardData.map(card => card.category))];

  const handleCardClick = (data) => {
    // Abrir PDF en nueva pestaña
    window.open(data.pdfUrl, '_blank');
    
    // Mostrar modal de confirmación
    setModalContent({
      title: '¡Descarga iniciada!',
      message: `El documento "${data.title}" se está descargando. También se abrió en una nueva pestaña.`,
      icon: 'success',
      data: data,
    });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  // Cerrar modal al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    
    if (modalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [modalOpen]);

  // Modal de confirmación mejorado
  const ConfirmationModal = () => {
    if (!modalOpen) return null;

    return (
      <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-4 animate-in fade-in duration-300">
        <div 
          ref={modalRef} 
          className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-3xl shadow-2xl p-8 w-full max-w-md transform transition-all duration-500 animate-in zoom-in-95"
        >
          <div className="text-center">
            {/* Icono animado */}
            <div className="relative w-24 h-24 mx-auto mb-6">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 to-cyan-400/30 rounded-full animate-ping"></div>
              <div className="absolute inset-2 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-full flex items-center justify-center shadow-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="7 10 12 15 17 10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
              </div>
            </div>
            
            <h3 className="text-2xl font-bold text-white mb-3">
              {modalContent.title}
            </h3>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              {modalContent.message}
            </p>
            
            {modalContent.data && (
              <div className="bg-gray-800/50 rounded-xl p-4 mb-6 border border-gray-700">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-xl overflow-hidden">
                    <img 
                      src={modalContent.data.imageUrl} 
                      alt={modalContent.data.title}
                      className="w-full h-full object-cover"
                      onError={(e) => e.target.src = "https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80"}
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-white">
                      {modalContent.data.title}
                    </h4>
                    <p className="text-sm text-gray-400">
                      {modalContent.data.category} • {modalContent.data.fileSize}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="flex gap-3">
            <button
              onClick={closeModal}
              className="flex-1 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-bold rounded-xl hover:from-blue-700 hover:to-cyan-600 transition-all duration-300 transform hover:scale-[1.02] active:scale-95"
            >
              Perfecto
            </button>
            
            <button
              onClick={() => {
                window.open(modalContent.data?.pdfUrl, '_blank');
                closeModal();
              }}
              className="flex-1 py-4 bg-gray-800 text-white font-bold rounded-xl hover:bg-gray-700 transition-all duration-300 transform hover:scale-[1.02] active:scale-95 border border-gray-700"
            >
              Abrir PDF
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Header mejorado
  const Header = () => (
    <div className="text-center mb-16 max-w-6xl mx-auto px-4">
      {/* <div className="inline-block mb-8 px-6 py-3 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-2xl border border-blue-500/20 backdrop-blur-sm">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 font-bold text-lg">
          Biblioteca Digital • {stats.total} Documentos
        </span>
      </div> */}
      
      <h1 className="text-5xl md:text-6xl font-black mb-8 tracking-tight">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-cyan-200 to-white animate-gradient">
          Fichas Técnicas
        </span>
        <br />
        <span className="text-4xl md:text-5xl text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
          Información Esencial
        </span>
      </h1>
      
      <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed">
        Explora nuestra colección completa de documentos técnicos sobre gestión ambiental y desarrollo sostenible. 
        <span className="block mt-2 text-cyan-300 font-medium">Cada ficha es una imagen completa con información integrada.</span>
      </p>
      
      {/* Estadísticas */}
      {/* <div className="flex flex-wrap justify-center gap-6 mb-10">
        <div className="backdrop-blur-sm bg-white/5 rounded-2xl p-5 border border-white/10 min-w-[180px] transform hover:scale-105 transition-all duration-300 hover:bg-white/10">
          <div className="text-3xl font-bold text-cyan-400 mb-2">{stats.total}</div>
          <div className="text-gray-400 text-sm">Documentos</div>
        </div>
        
        <div className="backdrop-blur-sm bg-white/5 rounded-2xl p-5 border border-white/10 min-w-[180px] transform hover:scale-105 transition-all duration-300 hover:bg-white/10">
          <div className="text-3xl font-bold text-blue-400 mb-2">{stats.totalSize}</div>
          <div className="text-gray-400 text-sm">Total</div>
        </div>
        
        <div className="backdrop-blur-sm bg-white/5 rounded-2xl p-5 border border-white/10 min-w-[180px] transform hover:scale-105 transition-all duration-300 hover:bg-white/10">
          <div className="text-3xl font-bold text-green-400 mb-2">{stats.totalPages}</div>
          <div className="text-gray-400 text-sm">Páginas</div>
        </div>
      </div> */}
    </div>
  );

  return (
    <div className="container mx-auto px-4 py-12">
      {/* Header */}
      <Header />
      
      {/* Filtros y búsqueda */}
      <div className="mb-12">
        <div className="flex flex-col md:flex-row gap-6 justify-between items-center mb-8">
          {/* Barra de búsqueda */}
          <div className="relative w-full md:w-auto md:flex-1 max-w-2xl">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-cyan-400">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </div>
            <input
              type="text"
              placeholder="Buscar fichas por título, descripción o categoría..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-4 bg-white/5 backdrop-blur-sm border border-white/10 text-white rounded-2xl shadow-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 placeholder-gray-400"
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm('')}
                className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-white"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            )}
          </div>
          
          {/* Filtro por categoría */}
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilterCategory(category)}
                className={`px-5 py-2.5 rounded-full font-bold transition-all duration-300 transform hover:scale-105 backdrop-blur-sm ${filterCategory === category 
                  ? 'bg-gradient-to-r from-blue-600 to-cyan-500 text-white shadow-lg shadow-blue-500/30' 
                  : 'bg-white/5 text-gray-300 hover:bg-white/10 border border-white/10'}`}
              >
                {category === 'all' ? 'Todas' : category}
              </button>
            ))}
          </div>
        </div>
        
        {/* Resultados de búsqueda */}
        {searchTerm && (
          <div className="text-center mb-6">
            <p className="text-cyan-300 font-medium">
              Mostrando {filteredCards.length} de {cardData.length} resultados para "<span className="text-white">{searchTerm}</span>"
            </p>
          </div>
        )}
      </div>
      
      {/* Grid de fichas */}
      {filteredCards.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {filteredCards.map((data, index) => (
            <div 
              key={data.id} 
              className="animate-in fade-in slide-in-from-bottom-4 duration-700"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <FichaDocumento data={data} onCardClick={handleCardClick} />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-20 backdrop-blur-sm bg-white/5 rounded-3xl border border-white/10">
          <div className="w-32 h-32 mx-auto mb-8 text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="12" y1="18" x2="12" y2="12"/>
              <line x1="9" y1="15" x2="15" y2="15"/>
            </svg>
          </div>
          <h3 className="text-3xl font-bold text-white mb-4">
            No se encontraron resultados
          </h3>
          <p className="text-gray-400 max-w-md mx-auto mb-8">
            No hay fichas que coincidan con "<span className="text-white">{searchTerm}</span>" en la categoría 
            "<span className="text-cyan-300">{filterCategory === 'all' ? 'Todas' : filterCategory}</span>".
          </p>
          <button
            onClick={() => {
              setSearchTerm('');
              setFilterCategory('all');
            }}
            className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-bold rounded-xl hover:from-blue-700 hover:to-cyan-600 transition-all duration-300 transform hover:scale-105 shadow-lg shadow-blue-500/30"
          >
            Mostrar todas las fichas
          </button>
        </div>
      )}
      
      {/* Footer informativo */}
      <div className="mt-20 pt-8 border-t border-white/10 text-center">
        <p className="text-gray-400 text-sm mb-6">
          Cada ficha es una imagen completa con información integrada. Haz clic en cualquier tarjeta para descargar el PDF.
        </p>
        {/* <div className="flex flex-wrap justify-center gap-8">
          <button className="text-sm text-cyan-400 hover:text-cyan-300 hover:underline flex items-center gap-2 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/>
              <path d="M18 14h-8"/>
              <path d="M15 18h-5"/>
              <path d="M10 6h8v4h-8V6Z"/>
            </svg>
            Descargar colección completa
          </button>
          <button className="text-sm text-cyan-400 hover:text-cyan-300 hover:underline flex items-center gap-2 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
            </svg>
            Solicitar asesoría técnica
          </button>
          <button className="text-sm text-cyan-400 hover:text-cyan-300 hover:underline flex items-center gap-2 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 16v-4"/>
              <path d="M12 8h.01"/>
            </svg>
            Cómo usar las fichas
          </button>
        </div> */}
      </div>
      
      {/* Modal de confirmación */}
      <ConfirmationModal />
    </div>
  );
};

// Componente App principal con fondo oscuro
const App = () => (
  <div className="min-h-screen font-sans bg-gradient-to-br from-gray-900 via-black to-gray-900 transition-colors duration-500">
    {/* Scripts de Tailwind */}
    <script src="https://cdn.tailwindcss.com"></script>
    <script src="https://cdn.tailwindcss.com?plugins=forms,typography,aspect-ratio,line-clamp"></script>
    
    {/* Estilos personalizados */}
    <style>
      {`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        :root {
          font-family: 'Inter', sans-serif;
        }
        
        /* Animación del gradiente del título */
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 4s ease infinite;
        }
        
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        
        /* Animaciones de entrada */
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slide-in-from-bottom {
          from { transform: translateY(30px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        @keyframes zoom-in {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        
        .animate-in {
          animation-duration: 0.6s;
          animation-fill-mode: both;
        }
        
        .fade-in {
          animation-name: fade-in;
        }
        
        .slide-in-from-bottom-4 {
          animation-name: slide-in-from-bottom;
        }
        
        .zoom-in-95 {
          animation-name: zoom-in;
          animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        /* Scrollbar personalizada */
        ::-webkit-scrollbar {
          width: 10px;
        }
        
        ::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 5px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: linear-gradient(to bottom, #0ea5e9, #06b6d4);
          border-radius: 5px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(to bottom, #0284c7, #0891b2);
        }
        
        /* Efecto de brillo en elementos */
        .glow-effect {
          position: relative;
        }
        
        .glow-effect::after {
          content: '';
          position: absolute;
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          background: linear-gradient(45deg, #0ea5e9, #06b6d4, #0ea5e9);
          border-radius: inherit;
          z-index: -1;
          opacity: 0;
          transition: opacity 0.3s;
        }
        
        .glow-effect:hover::after {
          opacity: 0.6;
        }
        
        /* Mejorar contraste de texto sobre imágenes */
        .text-shadow {
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
        }
        
        .text-shadow-lg {
          text-shadow: 0 4px 8px rgba(0, 0, 0, 0.7);
        }
      `}
    </style>
    
    <MainAppLogic />
  </div>
);

export default App;